import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "../lib/i18n";

export const FloatingWhatsApp = ({ lang }) => {
  const message =
    lang === "fr"
      ? "Bonjour PRESTIGE KEY, je vous contacte pour une demande de conciergerie."
      : "Hello PRESTIGE KEY, I'm reaching out for a concierge request.";

  return (
    <a
      data-testid="floating-whatsapp"
      href={buildWhatsAppLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="whatsapp-float fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-white text-black flex items-center justify-center shadow-[0_10px_40px_rgba(255,255,255,0.18)] hover:scale-105 transition-transform"
    >
      <MessageCircle size={22} strokeWidth={1.6} />
    </a>
  );
};
